import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import TrialExpiredContent from "./TrialExpiredContent";

interface TrialExpiredModalProps {
  isOpen: boolean;
  onSubscribe: (plan: "monthly" | "yearly" | "lifetime") => void;
}

export default function TrialExpiredModal({
  isOpen,
  onSubscribe,
}: TrialExpiredModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-md"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
          >
            <TrialExpiredContent onSubscribe={onSubscribe} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
